import * as React from 'react';
import moment from 'moment';
import {
  OfferSettingsJsonType,
  OfferSettingsSubmission,
  BuildJsonType,
} from '@bb/domain/dist/types';

type OfferInformationProps = {
  offerCount: number;
  offerSettings: Pick<
    OfferSettingsJsonType,
    | 'acceptedAnytime'
    | 'offerDate'
    | 'otherInstructions'
    | 'preemptive'
    | 'registration'
    | 'requestIrrevocable'
  >;
  offerSubmissions: BuildJsonType<OfferSettingsSubmission>;
};

const OfferInformation: React.FunctionComponent<OfferInformationProps> = ({
  offerCount,
  offerSettings,
  offerSubmissions,
}) => {
  // converting the Offer Submission object to string
  const submission = React.useMemo(() => offerSubmissions
      ? Object.entries(offerSubmissions)
          .reduce((submissions, [key, value]) => {
            if (!value) return submissions;
            const details = value.details ? ` - ${value.details}` : '';
            if (value.active) {
              switch (key) {
                case 'inPerson':
                  submissions.push(`In Person${details}`);
                  break;
                case 'email':
                  submissions.push(`Email${details}`);
                  break;
                case 'fax':
                  submissions.push(`Fax${details}`);
                  break;
                case 'other':
                  submissions.push(`Other${details}`);
                  break;
                default:
              }
            }
            return submissions;
          }, [])
          .join(' (or) ')
      : '', [offerSubmissions]);

  return (
    <>
      <h3>Information</h3>
      <hr />
      <h4>Currently {offerCount} Offers Registered</h4>
      <h5>Presentation Date</h5>

      <div>
        {offerSettings.acceptedAnytime
          ? 'Offers accepted anytime.'
          : moment(offerSettings.offerDate).format('MMM D, YYYY H:mm:ss A')}
      </div>

      {submission && (
        <div>
          <span>Offers to be presented by: {submission}</span>
        </div>
      )}
      {offerSettings.requestIrrevocable && (
        <div>
          <h5>Request Irrevocable</h5>
          <span>{offerSettings.requestIrrevocable} hours</span>
        </div>
      )}
      {offerSettings.otherInstructions && (
        <div>
          <h5>Other Instructions</h5>
          <span>{offerSettings.otherInstructions}</span>
        </div>
      )}
    </>
  );
};

export default OfferInformation;
